<template>
  <div id="Admin_Report">
    <v-title>
      <font-awesome-icon icon="chart-bar" />
      銷帳管理及報表
    </v-title>
    <hr>
    <!-- 內容 -->
    <div class="tab-content">
      <ul
        id="adminreport"
        class="nav nav-tabs"
        role="tablist"
      >
        <li class="nav-item">
          <a
            id="admin_detail"
            class="nav-link"
            :class="[isActive ? 'active' : '']"
            :href="'#/admin/report/detail'"
            @click="FeeorderList('1')"
            role="tab"
            aria-controls="sales_detail"
            aria-selected="true"
          >
            銷帳明細表
          </a>
        </li>
        <li class="nav-item">
          <a
            id="admin_all"
            class="nav-link"
            :class="[isActives ? 'active' : '']"
            :href="'#/admin/report/all'"
            @click="FeeorderList('2')"
            role="tab"
            aria-controls="sales_all"
            aria-selected="false"
          >
            銷帳總表
          </a>
        </li>
        <li class="nav-item">
          <a
            id="admin_query"
            class="nav-link"
            :class="[isActiveint ? 'active' : '']"
            :href="'#/admin/report/aquery'"
            @click="FeeorderList('3')"
            role="tab"
            aria-controls="sales_query"
            aria-selected="false"
          >
            重複繳費清單
          </a>
        </li>
      </ul>
      <!-- 銷帳明細表 -->
      <Detail v-if="isActive" />
      <!-- 銷帳總表 -->
      <All v-if="isActives" />
      <!-- 重複繳費清單 -->
      <Query v-if="isActiveint" />
    </div>
  </div>
</template>

<script>
import All from './AllFinancial'
import Detail from './DetailFinancial'
import Query from './QueryDuplicate'
export default {
  components: {
    All,
    Detail,
    Query
  },
  data () {
    return {
      isShow: false,
      isActive: true,
      isActives: false,
      isActiveint: false
    }
  },
  methods: {
    FeeorderList (data) { // 觸發切換頁籤
      const vm = this
      if (data === '1') {
        vm.isActive = true
        vm.isActives = false
        vm.isActiveint = false
      } else if (data === '2') {
        vm.isActive = false
        vm.isActives = true
        vm.isActiveint = false
      } else if (data === '3') {
        vm.isActive = false
        vm.isActives = false
        vm.isActiveint = true
      }
    }
  }
}
</script>
